import styled from 'styled-components';

export const ButtonFiles = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;

  input[type='file'] {
    display: none;
  }
  label,
  button {
    padding: 10px;
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    color: ${({ theme }) => {
      return theme.colors.black;
    }};
    background-color: ${({ theme }) => {
      return theme.colors.alert;
    }};
    border: none;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    cursor: pointer;
    transition: filter 200ms ease-in-out;
    &:hover {
      filter: brightness(85%);
    }
    &:disabled {
      cursor: not-allowed;
      background-color: ${({ theme }) => {
        return theme.colors.border;
      }};
    }
  }
  button {
    background-color: ${({ theme }) => {
      return theme.colors.error;
    }};
    color: ${({ theme }) => {
      return theme.colors.white;
    }};
  }
`;

export const WrapperListFiles = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin: 10px 0;

  div {
    padding: 5px;
    margin: 5px 5px 0 0;
    background-color: ${({ theme }) => {
      return theme.colors.white;
    }};
    border: ${({ theme }) => {
      return theme.border;
    }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};

    a {
      text-decoration: none;
      font-size: ${({ theme }) => {
        return theme.fonts.size.small;
      }};
      font-weight: ${({ theme }) => {
        return theme.fonts.weight.thin;
      }};
      margin-right: 5px;
      color: ${({ theme }) => {
        return theme.colors.primary;
      }};
    }
    button {
      background-color: ${({ theme }) => {
        return theme.colors.error;
      }};
      color: ${({ theme }) => {
        return theme.colors.white;
      }};
      font-size: ${({ theme }) => {
        return theme.fonts.size.small;
      }};
      font-weight: ${({ theme }) => {
        return theme.fonts.weight.thin;
      }};
      border: none;
      border-radius: ${({ theme }) => {
        return theme.borderRadius.small;
      }};
      cursor: pointer;
      transition: filter 200ms ease-in-out;
      &:hover {
        filter: brightness(85%);
      }
    }
  }
`;
